




import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { DialogProgrammatic as Dialog } from "buefy";
import { JinroRoomStatus } from "../../services/jinro-room-status";
import {
  JinroRoomDocument,
  JinroPlayerDocument,
} from "../../services/datatypes";
import JinroRoom from "../../views/JinroRoom.vue";
import JinroPlayer from "../../views/JinroPlayer.vue";

@Component({
  components: {},
})
export default class FriendlyFowaringToJinroPlayer extends Vue {
  @Prop() readonly jinroRoom!: JinroRoomDocument;

  get jinroRoomStatus(): JinroRoomStatus | null {
    if (!this.jinroRoom) {
      return null;
    }
    return this.jinroRoom.jinroRoomStatus;
  }

  @Watch("jinroRoomStatus")
  onChange() {
    this.friendlyFowaring();
  }

  friendlyFowaring() {
    if (this.jinroRoomStatus !== JinroRoomStatus.ProcessingNewGame) {
      return;
    }

    const userPlayer = this.getUserPlayer;
    if (!userPlayer) {
      this.friendlyDialogueToPublicViewing();
      return;
    }

    this.friendlyDialogue(userPlayer);
  }

  get getUserPlayer(): JinroPlayerDocument | undefined {
    if (!this.$store.state.jinroRoomPlayers) {
      return undefined;
    }
    const players = this.$store.state.jinroRoomPlayers as Array<
      JinroPlayerDocument
    >;
    const uid = this.uid;
    const userPlayer = players.find((player) => {
      return player.uid === uid;
    });

    return userPlayer;
  }

  get uid(): string {
    if (this.$store.state.user) {
      return this.$store.state.firebaseUser.uid;
    }

    return "";
  }

  get publicViewingUrl(): string {
    return this.$route.path + "/public";
  }

  friendlyDialogueToPublicViewing() {
    Dialog.confirm({
      message: this.dialogueMessageForPublicViewing,
      canCancel: true,
      cancelText: `キャンセル`,
      confirmText: `観戦画面に遷移する`,
      onConfirm: async () => this.$router.push(this.publicViewingUrl),
    });
  }

  friendlyDialogue(userPlayer: JinroPlayerDocument) {
    Dialog.confirm({
      message: this.dialogueMessage,
      canCancel: false,
      confirmText: `プレイヤー「 ${userPlayer.playerName}」画面に遷移する`,
      onConfirm: async () => this.$router.push(`/p/${userPlayer.id}`),
    });
  }

  get dialogueMessage(): string {
    if (this.isOwner) {
      return `ゲームオーナーとしてゲームに参加します。
    <br/>ゲームオーナーとして、下記のことが可能です。
    <br/>・プレイの一時中断/再開
    <br/>・ 任意のタイミングでプレイを次に進める (例: 昼時間を短縮して投票に進める)`;
    } else {
      return `ゲームが開始されます。<br/>プレイヤー画面に遷移します。`;
    }
  }

  get dialogueMessageForPublicViewing(): string {
    let msg = "";
    msg += "ゲームの観戦ページに移動します";
    msg += "<br/>＊見える情報は プレイヤーの村人と同程度となります";
    msg += "<br/>＊各プレイヤーの役職などはみえません";
    msg += "<br/>＊お昼後の投票などは、結果のみ見えます";

    if (this.isOwner) {
      msg += "<hr/>";
      msg += "<br/>ゲームオーナーとして、下記のことが可能です。";
      msg += "<br/>＊プレイの一時中断/再開";
      msg +=
        "<br/>＊ 任意のタイミングでプレイを次に進める (例: 昼時間を短縮して投票に進める)";
    }
    return msg;
  }

  get isOwner() {
    return (
      this.$store.state.firebaseUser &&
      this.jinroRoom.owner === this.$store.state.firebaseUser.uid
    );
  }
}
